<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { StepperItemProps } from 'reka-ui'
import { reactiveOmit } from '@vueuse/core'
import { StepperItem, useForwardProps } from 'reka-ui'
import { cn } from '@ds/lib/utils'

const props = defineProps<StepperItemProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')

const forwarded = useForwardProps(delegatedProps)
</script>

<template>
  <StepperItem
    v-slot="slotProps"
    v-bind="forwarded"
    :class="cn(
      // `group` is load-bearing: the indicator and separator style themselves
      // off this item's data-state through group-data-[...] variants.
      'flex items-center gap-2 group data-[disabled]:pointer-events-none',
      props.class,
    )"
  >
    <slot v-bind="slotProps" />
  </StepperItem>
</template>
